/**
 * @description 将url query中的某个key=value删除
 * @param url url不传则取当前页面url
 * @param pnm 要删除的key=value中的key
 * @returns 删除后的url
 */
const removeParam = (url: string, pnm: string): string => {
  if (!url) url = window.location.href;
  const reg1 = new RegExp('\\?' + pnm + '(=[^&]*)?');
  const reg2 = new RegExp('\\&' + pnm + '(=[^&]*)?');

  return url.replace(reg1, '?').replace(reg2, '').replace(/\?&/, '?').replace(/\?$/, '');
};

export default removeParam;
